import styles from "./main.module.css";
import { ReactComponent as Home } from "../../assets/svgs/home.svg";
import { ReactComponent as Examination } from "../../assets/svgs/examination.svg";
import { ReactComponent as StatementOfPurpose } from "../../assets/svgs/statement-of-purpose.svg";
import { ReactComponent as Transcript } from "../../assets/svgs/transcript.svg";
import { ReactComponent as Induction } from "../../assets/svgs/induction.svg";
import { ReactComponent as ExamDeferment } from "../../assets/svgs/exam-deferment.svg";
import { ReactComponent as PayDues } from "../../assets/svgs/pay-dues.svg";
import { ReactComponent as MyDocument } from "../../assets/svgs/my-document.svg";
import { ReactComponent as ActivityHistory } from "../../assets/svgs/activity-history.svg";
import { ReactComponent as StudyCenterLink } from "../../assets/svgs/study-center-link.svg";
import { ReactComponent as PaymentHistory } from "../../assets/svgs/payment-history.svg";
import SideBarItem from "./sideBarItem/main";

interface SideBarProps {
  icon?: React.ReactNode;
  name?: string;
  display?: string;
  className?: any;
}

const sideBarItems1 = [
  {
    icon: <Home />,
    name: "Home",
    link: "/home"
  },
  {
    icon: <Examination />,
    name: "Examination",
    link: "/examination"
  },
  {
    icon: <StatementOfPurpose />,
    name: "Statement Of Result",
    link: "/statement-of-result"
  },
  {
    icon: <Transcript />,
    name: "Transcript",
    link: "/transcript"
  },
  {
    icon: <Induction />,
    name: "Induction",
    link: "/induction"
  },
  {
    icon: <ExamDeferment />,
    name: "Exam Deferment",
    link: "/exam-deferment"
  },
];

const sideBarItems2 = [
  {
    icon: <PayDues />,
    name: "Pay Dues",
    link: "/pay-dues"
  },
  {
    icon: <PaymentHistory />,
    name: "Payment History",
    link: "/payment-history"
  },
];

const sideBarItems3 = [
  {
    icon: <MyDocument />,
    name: "Photo Card",
    link: "/photo-card"
  },
  {
    icon: <MyDocument />,
    name: "My Documents",
    link: "/my-documents"
  },
];

const sideBarItems4 = [
  {
    icon: <ActivityHistory />,
    name: "Activity history",
    link: "/activity-history"
  },
  {
    icon: <StudyCenterLink />,
    name: "Study Center Link",
    link: "/study-center"
  },
];

const SideBar: React.FC<SideBarProps> = ({
  display,
  className,
}) => {
  return (
    <aside
      className={className}
      style={{
        paddingInline: "12px",
        borderInlineEnd: "1px solid #E5E6E6",
        display: display,
      }}
    >
      <div className={styles.sideBarSub}>
        <div className={styles.mainSideBarItem}>
          <div className={styles.ciipmlogo}></div>
          <h1>CIPM</h1>
        </div>

        <div>
          {sideBarItems1.map((item, index) => (
            <SideBarItem key={index} name={item.name} icon={item.icon} link={item.link}/>
          ))}
        </div>

        <div>
          {sideBarItems2.map((item, index) => (
            <SideBarItem key={index} name={item.name} icon={item.icon} link={item.link} />
          ))}
        </div>

        <div>
          {sideBarItems3.map((item, index) => (
            <SideBarItem key={index} name={item.name} icon={item.icon} link={item.link} />
          ))}
        </div>

        <div>
          {sideBarItems4.map((item, index) => (
            <SideBarItem key={index} name={item.name} icon={item.icon} link={item.link}/>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
